/* Copyright 2021, Milkdown by Mirone. */
import { css } from '@emotion/css';
export const override = ({ palette, mixin, size, font }) => {
    var _a, _b;
    return css `
    .milkdown {
        color: ${palette('neutral', 0.87)};
        background: ${palette('surface')};

        position: relative;
        font-family: ${font.typography};
        margin-left: auto;
        margin-right: auto;
        ${(_a = mixin.shadow) === null || _a === void 0 ? void 0 : _a.call(mixin)};
        padding: 3.125rem 1.25rem;
        box-sizing: border-box;

        .editor {
            outline: none;
            & > * {
                margin: 1.875rem 0;
            }
        }

        .ProseMirror-selectednode {
            outline: ${size.lineWidth} solid ${palette('line')};
        }

        li.ProseMirror-selectednode {
            outline: none;
        }

        li.ProseMirror-selectednode::after {
            ${(_b = mixin.border) === null || _b === void 0 ? void 0 : _b.call(mixin)};
        }

        @media only screen and (min-width: 72rem) {
            max-width: 57.375rem;
            padding: 3.125rem 7.25rem;
        }

        & ::selection {
            background: ${palette('secondary', 0.38)};
        }
    }
`;
};
//# sourceMappingURL=override.js.map